module.exports = __webpack_public_path__ + "static/img/not_enough.85e47f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/not_enough.png
// module id = 2U4v
// module chunks = 3